import { defineComponent as _defineComponent } from 'vue'
import {
  TUITranslateService,
  TUIStore,
  StoreName,
  IConversationModel,
  SendMessageParams,
  TUIChatService,
} from "@tencentcloud/chat-uikit-engine";
import { ref } from "../../../../adapter-vue";
import ToolbarItemContainer from "../toolbar-item-container/index.vue";
import evaluateIcon from "../../../../assets/icon/evaluate.svg";
import Link from "../../../../utils/documentLink";
import Icon from "../../../common/Icon.vue";
import starIcon from "../../../../assets/icon/star.png";
import starLightIcon from "../../../../assets/icon/star-light.png";
import { CHAT_MSG_CUSTOM_TYPE } from "../../../../constant";
import { isPC, isH5, isApp, isUniFrameWork } from "../../../../utils/env";
import { isEnabledMessageReadReceiptGlobal } from "../../utils/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  starTotal: {
    type: Number,
    default: 5,
  },
},
  setup(__props) {

const props = __props



const container = ref();

const starList = ref<number>(props.starTotal);
const currentStarIndex = ref<number>(-1);
const comment = ref("");
const currentConversation = ref<IConversationModel>();

TUIStore.watch(StoreName.CONV, {
  currentConversation: (conversation: IConversationModel) => {
    currentConversation.value = conversation;
  },
});

const onDialogClose = () => {
  resetEvaluate();
};

const openLink = (link: any) => {
  if (isPC || isH5) {
    window.open(Link?.customMessage?.url);
  }
};

const closeDialog = () => {
  container?.value?.toggleDialogDisplay(false);
};

const resetEvaluate = () => {
  currentStarIndex.value = -1;
  comment.value = "";
};

const selectStar = (starIndex?: any) => {
  if (currentStarIndex.value === starIndex) {
    currentStarIndex.value = currentStarIndex.value - 1;
  } else {
    currentStarIndex.value = starIndex;
  }
};

const submitEvaluate = () => {
  if (currentStarIndex.value < 0) {
    return;
  }
  const options = {
    to:
      currentConversation?.value?.groupProfile?.groupID ||
      currentConversation?.value?.userProfile?.userID,
    conversationType: currentConversation?.value?.type,
    payload: {
      data: JSON.stringify({
        businessID: CHAT_MSG_CUSTOM_TYPE.EVALUATE,
        version: 1,
        score: currentStarIndex.value + 1,
        comment: comment.value,
      }),
      description: "对本次的服务评价",
      extension: "对本次的服务评价",
    },
    needReadReceipt: isEnabledMessageReadReceiptGlobal(),
  };
  TUIChatService.sendCustomMessage(options);
  // 提交后关闭 dialog
  // close dialog after submit evaluate
  container?.value?.toggleDialogDisplay(false);
};

return { __sfc: true,props, container, starList, currentStarIndex, comment, currentConversation, onDialogClose, openLink, closeDialog, resetEvaluate, selectStar, submitEvaluate, TUITranslateService, ToolbarItemContainer, evaluateIcon, Link, Icon, starIcon, starLightIcon, isPC, isUniFrameWork }
}

})